module.exports = __webpack_public_path__ + "media/images/webhooks/real_time_pre_transfer_and_post_call-47bb3a9c0dd910e375586b930fb3a9f5.png";